/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ReactElement } from 'react'
import { createElement } from 'react'

import { componentMap } from './component-map'

export const renderArticleElements = (
  articleBody: any = [],
  articleUrl?: string | undefined
): ReactElement =>
  articleBody.reduce((elements, currentElement) => {
    if (!currentElement?.contentTag && !currentElement?.tagName && !currentElement?.component) {
      if (!skipableElements.includes(currentElement?.name ?? '')) {
        console.error('ARTICLE RENDERER ERROR: Invalid article body json element:', {
          articleUrl: articleUrl ?? 'unknown',
          invalidElement: currentElement,
        })
      }

      return elements
    }

    if (currentElement.contentTag) {
      return elements.concat(renderArticleElements(currentElement.children, articleUrl))
    }
    /**
     * Text type elements are broken chunks that form a paragraph.
     * These are usually returned if a <p> has nested elements e.g.
     * <p>chunk <a href="url"> chunk</p>
     */
    if (currentElement.tagName === 'text') {
      return elements.concat(currentElement.innerText)
    }

    if (currentElement.component) {
      const component = componentMap[currentElement.component]
      const componentRequiresRenderer = componentsWithRenderers.includes(currentElement.component)

      return elements.concat(
        createElement(
          component || 'div',
          component
            ? {
                key: currentElement.props?.key || currentElement.id,
                ...currentElement.props,
                ...(componentRequiresRenderer ? { renderArticleElements } : {}),
              }
            : { key: currentElement.props?.key || currentElement.id },
          calculateElementContent(currentElement)
        )
      )
    }

    return elements.concat(
      createElement(
        currentElement.tagName,
        { ...currentElement.props, key: currentElement.props?.key || currentElement.id },
        calculateElementContent(currentElement)
      )
    )
  }, [])

const calculateElementContent = (
  element: any,
  articleUrl?: string | undefined
): string | ReactElement | null => {
  const { innerText, children } = element

  if (innerText) {
    return innerText
  }

  if (children) {
    return renderArticleElements(children, articleUrl)
  }

  return null
}

const componentsWithRenderers = ['CsvTable']

const skipableElements = ['logged-in-content', 'logged-out-content']
